module.exports = __webpack_public_path__ + "static/media/dummyUser.d4656c04.png";